import styled from "styled-components";

export const StyledIcon = styled.img`
  & svg path {
    fill: ${props => props.color};
  }
`;
